<template>
    <transition-group name="snack" tag="ul" class="snackbar">
        <li
            v-for="item in snackbars"
            :key="item.id"
            class="snackbar__item"
            :style="item.color"
        >
            {{ item.message }}
        </li>
    </transition-group>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const getters = [
    'snackbars',
];

export default {
    name: 'SnackBars',
    computed: {
        ...mapGetters(getters),
    },
    methods: {
    },
};
</script>

<style lang="scss" scoped>
    @import "../styles/rem";

    .snack-enter-active, .snack-leave-active {
        transition: opacity .5s;
    }
    .snack-enter, .snack-leave-to {
        opacity: 0;
    }

    .snack-move {
        transition: opacity 1s;
    }

    .snackbar {
        position: fixed;
        top: rem(129);
        right: 0;
        padding: 0;

        @include on-mobile {
            top: auto;
            bottom: 0;
            right: 4%;
            left: 4%;
        }

        &__item {
            list-style: none;
            border-width: rem(1);
            border-style: solid;
            border-radius: rem(4);
            min-width: rem(341);
            max-width: rem(341);
            padding: rem(16) rem(24);
            font-family: "Open Sans";
            font-style: normal;
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(24);
            margin-bottom: rem(24);

            @include on-mobile {
                border-width: mrem(1);
                border-radius: mrem(4);
                padding: mrem(16) mrem(24);
                font-size: mrem(14);
                line-height: mrem(24);
                margin-bottom: mrem(24);
                width: 100%;
                min-width: 100%;
                max-width: 100%;
            }
        }
    }
</style>
